import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useProducts(category) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    setLoading(true);
    api
      .get("/products", { params: category ? { category } : {} })
      .then((r) => active && setProducts(r.data))
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [category]);
  return { products, loading };
}
